import { render, staticRenderFns } from "./tixian_jilu.vue?vue&type=template&id=17363960&scoped=true"
import script from "./tixian_jilu.vue?vue&type=script&lang=js"
export * from "./tixian_jilu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17363960",
  null
  
)

export default component.exports